var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8174 15.6595C16.1874 14.5192 16.8653 13.5044 17.7767 12.7255C18.6881 11.9467 19.7982 11.4349 20.9823 11.247C22.1663 11.0591 23.3785 11.2022 24.4862 11.6607C25.5939 12.1193 26.5531 12.8756 27.258 13.8454C27.9628 14.8151 28.3849 15.9605 28.4791 17.1557C28.5734 18.3508 28.335 19.549 27.7908 20.6173C27.2467 21.6855 26.4186 22.5817 25.3965 23.2082C24.3743 23.8346 23.1988 24.1662 22 24.1662V26.3338M22 41.5C11.2304 41.5 2.5 32.7696 2.5 22C2.5 11.2304 11.2304 2.5 22 2.5C32.7696 2.5 41.5 11.2304 41.5 22C41.5 32.7696 32.7696 41.5 22 41.5ZM22.1079 32.8333V33.05L21.8921 33.0504V32.8333H22.1079Z",
    stroke: "#00A3FA",
    strokeWidth: 3.52083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.ff126d0f6238ec5c16a25dc89aed1e59.svg";
export { ForwardRef as ReactComponent };